import React, { useState } from 'react';
import './PinModal.css';

const PinModal = ({ isOpen, onClose, onSubmit }) => {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    if (!pin) {
      setError('Please enter a PIN.');
      return;
    }

    onSubmit(pin)
  .then((isValid) => {
    if (!isValid) {
      setError('Invalid PIN. Please try again.');
    } else {
      setError('');
      setPin('');
      onClose();
    }
  })
  .catch(() => {
    setError('Something went wrong. Please try again.');
  });
  };

  const handleClose = () => {
    setPin('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="pin-modal-backdrop">
      <div className="pin-modal">
        <h3>🔐 Enter Admin PIN</h3>
        <input
          type="password"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          placeholder="Enter PIN"
          className="pin-input"
        />
        {error && <p className="pin-error">{error}</p>}
        <div className="pin-actions">
          <button className="cancel-btn" onClick={handleClose}>Cancel</button>
          <button className="confirm-btn" onClick={handleConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  );
};

export default PinModal;